import Vue from 'vue'
import vuetify from './plugins/vuetify'
import './plugins/vuelidate'
import './plugins/vue-google-oauth2'
import i18n from './plugins/vue-i18n'
import App from './App.vue'
import router from './router'
import store from './store/store'

import { sync } from 'vuex-router-sync'
sync(store, router) // done. Returns an unsync callback fn

Vue.config.productionTip = false

new Vue({
  i18n,
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
